'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _OrganisationForm = require('../ui/OrganisationForm');

var _OrganisationForm2 = _interopRequireDefault(_OrganisationForm);

var _LogentryModel = require('../../logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _OrganisationModel = require('../model/OrganisationModel');

var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditOrganisation = function EditOrganisation(element, args) {
  var _this = this;

  _classCallCheck(this, EditOrganisation);

  this.onchange = function () {
    _this.data = _this.organisationForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('organisations', _this.data.getJSON()).then(function (organisation) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && organisation.id) {
        window.PRIM.navigate('/organisations/' + organisation.id, true);
      }

      if (organisation) {
        _this.data.values.id = organisation.id;
        _this.organisationForm.setValue(_this.data);
      }
    });
  };

  if (args && args.id) {
    window.PRIM.dataAccess.resolve('organisations', args.id, true).then(function (organisation) {
      _this.data = organisation;
      _this.organisationForm.setValue(_this.data);

      window.PRIM.dataAccess.resolve('locations', _this.data.values.id, true, 'organisation_id').then(function (locations) {
        for (var i = 0; i < locations.length; i++) {
          if (locations[i].values.id === _this.data.values.location_id) {
            _this.data.location = locations[i];
            _this.organisationForm.setValue(_this.data);
            break;
          }
        }

        _this.data.locations = locations;
        _this.locationIndex.setItems(_this.data.locations);
      }, function () {}).catch(function () {});

      window.PRIM.dataAccess.get('logentries').then(function (logentries) {
        var results = logentries.filter(function (logentry) {
          return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.organisation;
        });

        _this.data.logentries = results.map(function (logentry) {
          return new _LogentryModel2.default(logentry);
        });

        _this.logIndex.setItems(_this.data.logentries);
      }, function () {}).catch(function () {});
    }, function () {
      if (confirm('Deze organisatie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe organisatie aanmaken?')) {
        window.PRIM.navigate('/organisations/');
      } else {
        history.back();
      }
    }).catch(function () {});
  }

  this.data = new _OrganisationModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Organisatie bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/locations/new/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze organisatie.');
        }
      },
      icon: '\uE0A0',
      label: 'Vestiging'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/logentries/organisation/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze organisatie.');
        }
      },
      icon: '\uE032',
      label: 'Logboekregel'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze organisatie wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('organisations', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze organisatie.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  var primaryData = document.createElement('section');
  primaryData.className = 'primary';
  var secondaryData = document.createElement('section');
  secondaryData.className = 'secondary';

  this.organisationForm = new _OrganisationForm2.default(primaryData, { organisation: this.data, onchange: this.onchange });

  var fieldsetLocations = document.createElement('fieldset');
  var legendLocations = document.createElement('legend');
  legendLocations.innerHTML = 'Vestigingen';
  fieldsetLocations.appendChild(legendLocations);

  var onclickLocation = function onclickLocation(item) {
    window.PRIM.navigate('/locations/' + item.values.id);
  };

  this.locationIndex = new _IndexControl2.default(fieldsetLocations, { items: this.data.locations, onclick: onclickLocation });

  secondaryData.appendChild(fieldsetLocations);

  var fieldsetLog = document.createElement('fieldset');
  var legendLog = document.createElement('legend');
  legendLog.innerHTML = 'Logboek';
  fieldsetLog.appendChild(legendLog);

  var onclickLogentry = function onclickLogentry(item) {
    window.PRIM.navigate('/logentries/' + item.values.id);
  };

  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });

  secondaryData.appendChild(fieldsetLog);

  divContent.appendChild(primaryData);
  divContent.appendChild(secondaryData);
  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditOrganisation;


//////////////////
// WEBPACK FOOTER
// ./js/modules/organisation/action/EditOrganisation.js
// module id = 60
// module chunks = 0